import { EntityLibraryLoadStatus, GameLibraryState } from 'army-builder-shared/src/lib/global/army-builder-entity-store';
import {
    NaturalBehavior,
    BoostCard,
    EventCard,
    Environment,
    ReferenceCard,
    Equipment,
    Perk,
    Leader,
    Faction,
    UnitTemplate,
    AutomatronComponent
} from '../global/models';
import { GenericWastelandCard } from '../global/models/generic-wasteland-card.model';

export interface FWWLibraryState extends GameLibraryState {
    factions: { status: EntityLibraryLoadStatus; data: Faction[] };
    'unit-templates': { status: EntityLibraryLoadStatus; data: UnitTemplate[] };
    behaviors: { status: EntityLibraryLoadStatus; data: NaturalBehavior[] };
    explores: { status: EntityLibraryLoadStatus; data: GenericWastelandCard[] };
    strangers: { status: EntityLibraryLoadStatus; data: GenericWastelandCard[] };
    dangers: { status: EntityLibraryLoadStatus; data: GenericWastelandCard[] };
    creatures: { status: EntityLibraryLoadStatus; data: GenericWastelandCard[] };
    quests: { status: EntityLibraryLoadStatus; data: GenericWastelandCard[] };
    boosts: { status: EntityLibraryLoadStatus; data: BoostCard[] };
    events: { status: EntityLibraryLoadStatus; data: EventCard[] };
    environments: { status: EntityLibraryLoadStatus; data: Environment[] };
    purposes: { status: EntityLibraryLoadStatus; data: GenericWastelandCard[] };
    battlefields: { status: EntityLibraryLoadStatus; data: GenericWastelandCard[] };
    'reference-cards': { status: EntityLibraryLoadStatus; data: ReferenceCard[] };
    equipment: { status: EntityLibraryLoadStatus; data: Equipment[] };
    automatrons: { status: EntityLibraryLoadStatus; data: AutomatronComponent[] };
    perks: { status: EntityLibraryLoadStatus; data: Perk[] };
    leaders: { status: EntityLibraryLoadStatus; data: Leader[] };
}

export const initialFWWLibraryState: FWWLibraryState = {
    factions: { status: 'NOT_STARTED', data: null },
    'unit-templates': { status: 'NOT_STARTED', data: null },
    behaviors: { status: 'NOT_STARTED', data: null },
    explores: { status: 'NOT_STARTED', data: null },
    strangers: { status: 'NOT_STARTED', data: null },
    dangers: { status: 'NOT_STARTED', data: null },
    creatures: { status: 'NOT_STARTED', data: null },
    quests: { status: 'NOT_STARTED', data: null },
    boosts: { status: 'NOT_STARTED', data: null },
    events: { status: 'NOT_STARTED', data: null },
    environments: { status: 'NOT_STARTED', data: null },
    purposes: { status: 'NOT_STARTED', data: null },
    battlefields: { status: 'NOT_STARTED', data: null },
    'reference-cards': { status: 'NOT_STARTED', data: null },
    equipment: { status: 'NOT_STARTED', data: null },
    automatrons: { status: 'NOT_STARTED', data: null },
    perks: { status: 'NOT_STARTED', data: null },
    leaders: { status: 'NOT_STARTED', data: null }
};
